import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Button, Form, Input, Modal } from 'antd';
import { useManageOrganization } from './context';

interface CreateOrganizationProps {
	open: boolean;
	onClose: () => void;
}

const { useForm } = Form;

export const CreateOrganization: React.FC<CreateOrganizationProps> = ({ open = false, onClose }) => {
	const [form] = useForm();
	const { handleCreateOrganization } = useManageOrganization();

	async function onSubmit() {
		const name = await form.getFieldsValue();
		const notExistSameName = await handleCreateOrganization(name);

		if (notExistSameName) {
			onClose();
			form.resetFields();
		}
	}

	return (
		<Modal
			open={open}
			onCancel={onClose}
			title={I18n.get('Create new company')}
			footer={[
				<Button key="cancel" onClick={onClose}>
					{I18n.get('Cancel')}
				</Button>,
				<Button key="save" type="primary" onClick={onSubmit}>
					{I18n.get('Save')}
				</Button>
			]}
		>
			<Form form={form} layout="vertical" name="create_user">
				<Form.Item
					name="name"
					label={I18n.get('Name')}
					rules={[
						{
							required: true,
							message: I18n.get('Please enter a valid name')
						}
					]}
				>
					<Input placeholder={I18n.get('Name')} />
				</Form.Item>
			</Form>
		</Modal>
	);
};
